module.exports = __webpack_public_path__ + "img/logomarca.fcaa2083.svg";